const text_card_carousels = () => {
    let threeColModule = $('.text-card-three-col_carousel');
    let twoColModule = $('.text-card-two-col_carousel');
    let iconModule = $('.text-card-icon_carousel');
    let logoModule = $('.text-card-logo_carousel');

    iconModule.each(function() {
        let $this = $(this);
        let $cardIconSlider = $this.find('.text-card-icon_carousel--wrapper_inner');
        let dotWidth;

        $cardIconSlider.slick({
            dots: true,
            infinite: true,
            autoplay: false,
            centerMode: true,
            slidesToShow: 1,
            prevArrow: $this.find('.text-card-icon_carousel--navigation_prev'),
            nextArrow: $this.find('.text-card-icon_carousel--navigation_next'),
            customPaging : function(slider, i) {
                dotWidth = 100 / slider.slideCount
                return '<a href="#" class="pagingDot"></a>';
            },
        });

        $this.find('.pagingDot').parent('li').css('width', dotWidth + '%');
    });

    logoModule.each(function() {
        let $this = $(this);
        let $cardlogoSlider = $this.find('.text-card-logo_carousel--wrapper_inner');
        let dotWidthLogo;

        $cardlogoSlider.slick({
            dots: true,
            infinite: true,
            autoplay: false,
            centerMode: true,
            slidesToShow: 1,
            prevArrow: $this.find('.text-card-logo_carousel--navigation_prev'),
            nextArrow: $this.find('.text-card-logo_carousel--navigation_next'),
            customPaging : function(slider, i) {
                dotWidthLogo = 100 / slider.slideCount
                return '<a href="#" class="pagingDotLogo"></a>';
            },
        });

        $this.find('.pagingDotLogo').parent('li').css('width', dotWidthLogo + '%');
    });

    twoColModule.each(function() {
        let $this = $(this);
        let $sliderTwo = $this.find('.text-card-two-col_carousel--wrapper_inner');
        let $progressBarTwo = $this.find('.text-card-two-col_carousel_progress');
        let $progressBarLabelTwo = $this.find('.text-card-two-col_carousel_slider__label');

        $sliderTwo.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            let calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

            $progressBarTwo
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc );
        });

        $sliderTwo.slick({
            dots: false,
            infinite: true,
            autoplay: false,
            slidesToShow: 1,
            prevArrow: "",
            nextArrow: $this.find('.text-card-two-col_carousel--wrapper_next'),

            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        prevArrow: $this.find('.text-card-two-col_carousel--navigation_prev'),
                        nextArrow: $this.find('.text-card-two-col_carousel--navigation_next'),
                    }
                },
            ]

            
        });
    });

    threeColModule.each(function() {
        let $this = $(this);
        let $slider = $this.find('.text-card-three-col_carousel--wrapper_inner');
        let $progressBar = $this.find('.progress');
        let $progressBarLabel = $this.find('.slider__label');

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            let calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc );
        });

        $slider.slick({
            dots: false,
            infinite: true,
            autoplay: false,
            slidesToShow: 3,
            prevArrow: $this.find('.text-card-three-col_carousel--navigation_prev'),
            nextArrow: $this.find('.text-card-three-col_carousel--navigation_next'),
            responsive: [
                {
                    breakpoint: 998,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    });
};


export default text_card_carousels;